import dynamic from 'next/dynamic';
import { BrandedBannerProps } from './BrandedBanner.types';

export const BrandedBannerMGP = dynamic<BrandedBannerProps>(() => import('./BrandedBanner'));
